import {useSelector} from "react-redux";
import React from "react";
import MobileHeader from "./MobileHeader";
import DesktopHeader from "./DeskTopHeader";
const Header = React.memo(function() {
    const isMobile = useSelector((state) => state.user.isMobile);
    return isMobile ? <MobileHeader /> : <DesktopHeader />
})

export default Header